import { useNavigate } from "react-router"
import { useFieldArray, useForm } from "react-hook-form"

import { PayoutApi } from "services/api/PayoutApi"
import { CreateCalculatorType } from "models/payout"
import { ROUTER_NAMES } from "router/routerNames"

import { TextField } from "components/TextField"
import { AppButton } from "components/AppButton"

import styles from '../EditPage/EditPage.module.scss'
import { calculatorResolver } from "../_helpers/calculator-resolver"

export const CalculatorPlanCreate = () => {
  const navigate = useNavigate()
  const { register, control, handleSubmit, formState: { errors } } = useForm<CreateCalculatorType>({
    resolver: calculatorResolver
  })

  const planValues = useFieldArray({
    control,
    name: 'plan.values'
  })

  const onSubmit = (values: CreateCalculatorType) => {
    PayoutApi.createCalc(values).then(() => {
      navigate(`${ROUTER_NAMES.CALCULATORS}`)
    })
  }

  const removeValue = (idx: number) => {
    planValues.remove(idx)
  }

  const addValue = () => {
    planValues.append({
      id: 0,
      count: '',
      sum: '',
    })
  }

  return <div className="container">
    <form className={styles.form}>
      <div>

        <TextField
          {...register("one_time_payout", {
            required: "Заполните это поле",
          })}
          inputSize="small"
          type="number"
          label="Платеж за готовую карту"
          required
          withError
          error={errors.one_time_payout}
        />

        <TextField
          {...register("instant_payout", {
            required: "Заполните это поле",
          })}
          inputSize="small"
          type="number"
          label="Моментальный бонус"
          required
          withError
          error={errors.instant_payout}
        />

        <TextField
          {...register("plan.name", {
            required: "Заполните это поле",
          })}
          inputSize="small"
          label="Название плана"
          required
          withError
          error={errors.plan?.name}
        />
        <AppButton onClick={handleSubmit(onSubmit)}>
          Сохранить
        </AppButton>
        <AppButton
          onClick={() => navigate(ROUTER_NAMES.CALCULATORS)}
          variant="siren_border"
          style={{marginTop: 20}}
        >Назад</AppButton>
      </div>

      <div>
        <table>
          <thead>
            <tr>
              <th>Количество</th>
              <th>Бонус за план</th>
            </tr>
          </thead>
          <tbody>
            {planValues.fields.map((pVal, index) => {
              return (
                <tr>
                  <td>
                    <input type="number"
                      {...register(`plan.values.${index}.count`, {
                        required: "Заполните это поле",
                      })} />
                  </td>
                  <td>
                    <input type="number"
                      {...register(`plan.values.${index}.sum`, {
                        required: "Заполните это поле",
                      })} />
                  </td>
                  <td>
                    <AppButton variant="red" type="button" tabIndex={-1} onClick={() => removeValue(index)}>
                      Удалить
                    </AppButton>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <AppButton variant="siren_border" type="button" onClick={addValue}>
          Добавить
        </AppButton>
      </div>
    </form>
  </div>
}